/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ floor: NonNullable<unknown> }} Geofloorlegend2Inputs */

const en_geofloorlegend2 = /** @type {(inputs: Geofloorlegend2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Shown from ${i?.floor} people per area.`)
};

const de_geofloorlegend2 = /** @type {(inputs: Geofloorlegend2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ab ${i?.floor} Personen pro Gebiet sichtbar.`)
};

/**
* | output |
* | --- |
* | "Shown from {floor} people per area." |
*
* @param {Geofloorlegend2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geofloorlegend2 = /** @type {((inputs: Geofloorlegend2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geofloorlegend2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geofloorlegend2(inputs)
	return de_geofloorlegend2(inputs)
});
export { geofloorlegend2 as "geoFloorLegend" }